module.exports = __webpack_public_path__ + "img/graph-2-chart.c1b2bfde.png";